module.exports = __webpack_public_path__ + "img/nz.7dab6e5e.svg";